module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add":"Neu","departments":"Abteilungen"},"en":{"add":"Add","departments":"Departments"}}')
  delete Component.options._Ctor
}
